<template>
  <v-card tile flat>
    <v-card-text class="pa-0">
      <slot></slot>
    </v-card-text>

    <v-slide-y-transition>
      <v-toolbar
        class="pl-0 inline-editor-toolbar elevation-1"
        height="32"
        flat
        v-if="selection"
        v-bind="toolbarProps"
        ref="inlineToolbar"
      >
        <v-btn class="heading-activator" small text tile>Heading</v-btn>

        <v-menu activator=".heading-activator" close-on-click nudge-bottom="32">
          <v-list>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'P')">
                <v-btn text>
                  <p class="mb-0">Paragraph</p>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H1')">
                <v-btn text>
                  <h1>Heading 1</h1>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H2')">
                <v-btn text>
                  <h2>Heading 2</h2>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H3')">
                <v-btn text>
                  <h3>Heading 3</h3>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H4')">
                <v-btn text>
                  <h4>Heading 4</h4>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H5')">
                <v-btn text>
                  <h5>Heading 5</h5>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense>
              <v-list-item-title @click="applyFormat('formatBlock', 'H6')">
                <v-btn text>
                  <h6>Heading 6</h6>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-divider vertical class="mx-2"></v-divider>

        <v-btn small icon tile @click="applyFormat('bold')">
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>
        <v-btn small icon tile @click="applyFormat('italic')">
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>
        <v-btn small icon tile @click="applyFormat('underline')">
          <v-icon>mdi-format-underline</v-icon>
        </v-btn>

        <v-divider vertical class="mx-2"></v-divider>

        <v-btn small icon tile @click="applyFormat('justifyLeft')">
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>
        <v-btn small icon tile @click="applyFormat('justifyCenter')">
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>
        <v-btn small icon tile @click="applyFormat('justifyRight')">
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>

        <v-divider vertical class="mx-2"></v-divider>

        <v-btn small icon tile @click="createLink()">
          <v-icon>mdi-link-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </v-slide-y-transition>
    {{ editedSections }}
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import swal from 'sweetalert2'

export default {
  name: 'InlineEditor',
  data: () => ({
    selection: null,
    toolbarWidth: 0
  }),
  computed: {
    ...mapState('inline', ['editedSections']),
    toolbarProps() {
      if (!this.selection) {
        return null
      }

      let selectionRect = this.selection.getRangeAt(0).getBoundingClientRect()

      let rightPos =
        selectionRect.left + this.toolbarWidth + 20 > window.innerWidth

      return {
        style: {
          top: selectionRect.top + selectionRect.height + window.scrollY + 'px',
          left: rightPos ? 'auto' : selectionRect.left + 'px',
          right: rightPos
            ? window.innerWidth - selectionRect.right + 'px'
            : 'auto'
        }
      }
    }
  },
  methods: {
    createLink() {
      let sLink = prompt('Write the URL here', 'http://')

      if (sLink && sLink != '' && sLink != 'http://') {
        this.applyFormat(
          'createlink',
          `<a href="${sLink}" target="_blank">${this.selection}</a>`
        )
      }
    },
    applyFormat(cmd, value = null) {
      document.execCommand(cmd, false, value)
    },
    enableInlineEditor() {
      document.addEventListener(
        'selectionchange',
        this.toggleInlineToolbar,
        false
      )
    },
    disableInlineEditor() {
      document.removeEventListener(
        'selectionchange',
        this.toggleInlineToolbar,
        false
      )
    },
    toggleInlineToolbar() {
      let selection = document.getSelection()

      if (
        selection.type == 'Range' &&
        document.activeElement.getAttribute('contenteditable')
      ) {
        this.selection = null
        this.selection = document.getSelection()

        this.$nextTick(() => {
          this.toolbarWidth = this.$refs.inlineToolbar.$el.clientWidth
        })
      } else {
        this.selection = null

        this.$nextTick(() => {
          this.toolbarWidth = 0
        })
      }
    }
  },
  mounted() {
    document.execCommand('defaultParagraphSeparator', false, 'p')
    this.enableInlineEditor()
  },
  destroyed() {
    this.disableInlineEditor()
  }
}
</script>

<style scoped>
.inline-editor-toolbar {
  position: absolute;
  z-index: 1000;
  margin-top: 10px;
  transition: all 0.5s ease 0s;
}
</style>